import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-flag-icon',
  templateUrl: './communication-flag.component.html'
})
export class CommunicationFlagComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
